import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import './index.css';

// Import utilities  
import { initSentry } from './utils/sentry';
import { analytics } from './utils/analytics';
import { metaPixel } from './utils/meta-pixel';
import { clarity } from './utils/clarity';
import { createSkipToContentLink } from './utils/accessibility';

// Initialize services with error handling
const initializeServices = () => {
  try {
    // Initialize Sentry in production
    if (process.env.NODE_ENV === 'production') {
      initSentry();
    }
  } catch (error) {
    console.warn('Failed to initialize Sentry:', error);
  }

  try {
    // Initialize Google Analytics 4
    analytics.init({
      debugMode: process.env.NODE_ENV === 'development',
      consentGiven: true // You can integrate with cookie consent here
    });
  } catch (error) {
    console.warn('Failed to initialize analytics:', error);
  }

  try {
    // Initialize Meta Pixel
    metaPixel.init({
      debugMode: process.env.NODE_ENV === 'development',
      consentGiven: true // You can integrate with cookie consent here
    });
  } catch (error) {
    console.warn('Failed to initialize analytics:', error);
  }

  try {
    // Initialize Microsoft Clarity
    clarity.init();
  } catch (error) {
    console.warn('Failed to initialize Clarity:', error);
  }

  try {
    // Add skip to content link for accessibility
    createSkipToContentLink('main-content');
  } catch (error) {
    console.warn('Failed to create accessibility link:', error);
  }
};

// Initialize services
initializeServices();

// Render app
const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);